<template>
<b-container fluid>
  <bo-page-title />

  <b-card no-body>
    <b-card-header>
      <b-row>
        <b-col lg="5">
          <h5 class="card-title">{{ pageTitle }} List</h5>
        </b-col>
        <b-col lg="3">
        </b-col>
        <b-col lg="4">
          <SearchInput :value.sync="filter.search" @search="doFilter" />
        </b-col>
      </b-row>
    </b-card-header>
    <b-card-body class="p-0">
      <b-table
        :fields="fields"
        :items="dataList||[]"
        :primary-key="idKey"
        :busy="!dataList"
        @sort-changed="sorting"
        :no-local-sorting="true"
        responsive
        show-empty
        striped
      >
        <template #empty>
          <div class="text-center">
            <b-img class="mb-2" width="90" fluid src="/assets/images/no-data.png" />
            <h4 align="center"><span v-if="Object.keys($route.query).length">No search results found</span><span v-else>No {{ pageTitle }} listed yet</span></h4>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-3 text-info"></b-spinner>
            <strong class="text-info">Loading...</strong>
          </div>
        </template>
        <template #cell(number)="v">
          {{(data.per_page*(data.current_page-1))+v.index+1}}
        </template>
        <template #cell(an_title)="data">
          <p class="mb-1" style="font-weight:500">
            <a @click="open(data.item)" href="javascript:;">
              {{ data.value }}
            </a>
          </p>
          <template v-if="(data.item.an_tags||[]).length">
            <span v-for="(v, k) in data.item.an_tags" :key="k" class="badge border border-info text-info mr-1"
            >{{ v }}</span>
          </template>
        </template>
        <template #cell(latest_updated)="data">
          {{(data.item.an_updated_at||data.item.an_created_at) | moment("DD MMM YYYY HH:mm:ss")}}
        </template>
        <template
          #cell(action)="data"
        >
          <a @click="open(data.item)"
            href="javascript:;"
            v-b-tooltip.hover
            title="View"
            class="icon_action"
            style="cursor:pointer;"
          >
            <i class="ti-eye"></i>
          </a>
          <router-link
            v-if="moduleRole('edit')"
            v-b-tooltip.hover
            title="Edit"
            class="icon_action"
            :to="{name: $route.name, params: {pageSlug: data.item[idKey]}}"
            style="cursor:pointer;"
          >
            <i class="ti-marker-alt"></i>
          </router-link>
          <a
            v-if="moduleRole('delete')"
            v-b-tooltip.hover
            title="Delete"
            class="icon_action"
            @click="doDelete(data.index, data.item)"
            style="cursor:pointer;"
          >
            <i class="ti-trash"></i>
          </a>
        </template>
      </b-table>
    </b-card-body>
    <b-card-footer>
      <template v-if="(dataList||[]).length&&data.total>10">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <label for="perPage" class="mb-0 mr-2">Show</label>
              <b-form-select
                size="sm"
                id="perPage"
                class="w-auto mx-50"
                v-model="perPage"
                :options="Config.dataShownOptions"
              />
            <label for="perPage" class="mb-0 ml-2">items per page</label>
          </div>
          <b-pagination
            class="mb-0"
            v-model="pageNo"
            :per-page="data.per_page"
            :total-rows="data.total"
          />
        </div>
      </template>
    </b-card-footer>
  </b-card>

  <template v-if="isList">
    <b-modal
      v-model="view"
      title="Detail Notes"
      centered
      hide-footer
      size="xl"
    >
      <b-card v-if="row.an_id" no-body class="m-0">
        <b-card-body>
          <b-row>
            <b-col md="7">
              <div class="detail-info">
                <h4 style="font-weight: 500;">{{ row.an_title }}</h4>
                <div v-if="(row.an_tags||[]).length">
                  <span v-for="(v, k) in row.an_tags" :key="k" class="badge border border-info text-info mr-1"
                  >{{ v }}</span>
                </div>
              </div>
            </b-col>
            <b-col md="2">
              <div class="detail-info">
                <span style="font-size: 12px;font-weight: 400;">Creator</span>
                <h6 style="font-weight: 400;">{{ row.an_creator }}</h6>
              </div>
            </b-col>
            <b-col md="2">
              <div class="detail-info">
                <span style="font-size: 12px;font-weight: 400;">Latest Updated</span>
                <h6 style="font-weight: 400;">
                  {{(row.an_updated_at||row.an_created_at) | moment("DD MMM YYYY HH:mm:ss")}}
                </h6>
              </div>
            </b-col>
            <b-col md="1" align="right">
              <b-button type="button" variant="info" :to="{name: $route.name, params: {pageSlug: row[idKey]}}">Edit</b-button>
            </b-col>
            <div class="clearfix m-0"></div>
            <b-col md="12">
              <div class="card shadow p-3 mb-5 bg-body-tertiary rounded">
                <div class="card-body">
                  <div v-html="row.an_content" />
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-modal>
  </template>

  <template v-if="!isList">
    <Form :pageSlug.sync="formSlug" :rowModal.sync="row" />
  </template>
</b-container>
</template>
<script>
import GlobalVue from '@/libs/Global.vue'
import Form from './Form.vue'
// import Gen from '@/libs/Gen'

export default {
  extends: GlobalVue,
  components:{Form},
  data() {
    return {
      formSlug: '',
      idKey:'an_id',
      statusKey:'',
      mrValidation: {},
      dataModal: {},
      fields: [
        {
          key: 'number', label: '#', 
        },
        {
          key: 'an_title', label: 'Title', sortable: true, sortKey: 'an_title'
        },
        {
          key: 'an_creator', label: 'Creator',
        },
        {
          key: 'latest_updated', label: 'Latest Updated',
        },
        {
          key: 'action', 
        },
      ],
      view: false,
      row: {}
    }
  },
  mounted(){
    if (this.isList) {
      this.apiGet()
    }
  },
  methods: {
    sorting(e){
      this.filter.sort = e.sortBy + '-' + (e.sortDesc ? 'desc' : 'asc')
      this.$nextTick(() => {
        this.doFilter()
      })
    },
    open(item) {
      this.row = item
      this.$nextTick(() => {
        this.view = true
      })
    }
  },
  watch:{
    $route(){
      if (this.isList && this.formSlug !== 'canceled') {
        this.apiGet()
      }
    },
    '$route.params.pageSlug': function(v) {
      this.formSlug = v
    }
  }
}
</script>